import { Component, inject } from '@angular/core';
import { ModelService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ModelCreateDto,
  ModelDto,
  ModelExcelDownloadDto,
  ModelUpdateDto,
} from '../proxy/general/dtos/model';
import { MODEL_CONFIG, MODEL_FIELDS } from './model.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-model',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ModelService, ConfirmationService],
  templateUrl: './model.html',
  styleUrl: './model.scss',
})
export class Model extends BaseCrudComponent<
  ModelDto,
  ModelCreateDto,
  ModelUpdateDto,
  ModelExcelDownloadDto
> {
  service = inject(ModelService);
  config = MODEL_CONFIG;
  fields = MODEL_FIELDS;

  protected prepareUpdateDto(data: any, selected: ModelDto): ModelUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Model';
  }
}
